<template>
  <div>
    <v-dialog v-model="show_dialog_box" max-width="800px">
      <template v-slot:activator="{ on }">
        <v-icon v-on="on" color="dark">mdi-square-edit-outline</v-icon>
      </template>
      <v-card color="pop_bg">
        <v-card-title>
          <span class="text-h6 dark--text">Edit Gateway Charges</span>
          <v-spacer></v-spacer>
          <v-btn color="dark" text @click="close"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container class="mt-2">
            <v-form @submit="updateFaq()" v-model="valid" ref="form">
              <v-layout wrap>
                <!-- <v-flex xs12 sm2 md2 class="mt-3">
                  <h4 class="text-body-2 dark--text">Type.No</h4>
                </v-flex>
                <v-flex xs12 sm7 md3 class="mx-4">
                  <v-text-field
                    solo
                    name="input-7-4"
                    label="Type No."
                    v-model="data.type"
                    :rules="[requiredValidator('type')]"
                  ></v-text-field>
                </v-flex> -->

                <v-flex xs12 sm2 md2 class="mt-3">
                  <h4 class="text-body-2 dark--text">Transaction Type</h4>
                </v-flex>
                <v-flex xs12 sm7 md3>
                  <v-text-field solo name="input-7-4" label="Transaction Type" v-model="data.transactionType" :disabled="true" :rules="[requiredValidator('transactionType')]"></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout wrap>
                <v-flex xs12 sm2 md2 class="mt-3">
                  <h4 class="text-body-2 dark--text">Type</h4>
                </v-flex>
                <v-flex xs12 sm7 md3 class="mx-4">
                  <v-checkbox solo name="input-7-4" label="In Percentage" v-model="data.isInPercentage"></v-checkbox>
                </v-flex>

                <v-flex xs12 sm2 md2 class="mx-4 mt-3">
                  <h4 class="text-body-2 dark--text">Charge</h4>
                </v-flex>
                <v-flex xs12 sm7 md3>
                  <v-text-field solo name="input-7-4" type="number" label="Transaction Type" v-model="data.transactionCharge" :rules="[requiredValidator('transaction charge')]">
                    <template v-slot:append>
                      <v-icon v-show="data.isInPercentage"> mdi-percent </v-icon>
                    </template>
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="justify-end mt-n8">
          <v-btn color="primary" class="mb-2 light--text mb-sm-4 text-capitalize" :width="$vuetify.breakpoint.smAndUp ? 120 : 90" @click="updateFaq" :loading="btnloading" :disabled="!valid">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" timeout="3000" right top color="success">
      {{ text }}
    </v-snackbar>
  </div>
</template>

<script>
import { requiredValidator } from "../../core/methods/validations";

export default {
  props: {
    data: {
      required: true,
    },
  },
  data() {
    return {
      btnloading: false,
      valid: true,
      errors: [],
      snackbar: false,
      text: "",
      question: "",
      answer: "",
      showOrder: 0,
      active: true,
      show_dialog_box: false,
      requiredValidator: requiredValidator,
    };
  },
  methods: {
    close() {
      this.show_dialog_box = false;
    },
    updateFaq() {
      this.btnloading = true;
      this.$apollo
        .mutate({
          mutation: require("../api/updatePaymentGatewayCharge.graphql"),
          variables: {
            id: this.data._id,
            gateway: this.data.gateway,
            transactionType: this.data.transactionType,
            isInPercentage: this.data.isInPercentage,
            transactionCharge: parseFloat(this.data.transactionCharge),
            type: parseInt(this.data.type),
          },
          update: () => {
            // this.$refs.form.reset();
            this.btnloading = false;
            this.show_dialog_box = false;
          },
        })
        .catch(error => {
          if (error.graphQLErrors != null) {
            console.error(error.graphQLErrors);
          }
          this.btnloading = false;
        });
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
